import styled, { css } from 'styled-components';
import { transparentize } from 'polished';
import { motion } from 'framer-motion';
export var ARROW_SIZE = 8;
export var CONTENT_PADDING = 1.8;
export var MARGIN = 12;
export var Arrow = styled.span.withConfig({
  displayName: "elements__Arrow",
  componentId: "sc-12ljg9s-0"
})(["color:", ";position:absolute;display:inline-block;font-size:", "px;", " ", " ", " ", ""], function (_ref) {
  var palette = _ref.theme.palette;
  return palette.white;
}, ARROW_SIZE * 2, function (_ref2) {
  var placement = _ref2.placement;
  return placement.startsWith('top') && css(["bottom:", "rem;left:calc(50% - ", "px);margin-bottom:0;margin-top:0;text-shadow:1px -5px 5px ", ";transform:rotate(180deg);"], -CONTENT_PADDING + 0.5, ARROW_SIZE, function (_ref3) {
    var palette = _ref3.theme.palette;
    return transparentize(0.9, palette.black);
  });
}, function (_ref4) {
  var placement = _ref4.placement;
  return placement.startsWith('bottom') && css(["top:", "rem;left:calc(50% - ", "px);margin-bottom:0;margin-top:0;text-shadow:1px -4px 6px ", ";transform:rotate(0deg);"], -CONTENT_PADDING + 0.5, ARROW_SIZE, function (_ref5) {
    var palette = _ref5.theme.palette;
    return transparentize(0.9, palette.black);
  });
}, function (_ref6) {
  var placement = _ref6.placement;
  return placement.startsWith('left') && css(["right:", "rem;top:calc(50% - ", "px);margin-left:0;margin-right:0;text-shadow:1px -5px 5px ", ";transform:rotate(90deg);"], -CONTENT_PADDING + 0.8, ARROW_SIZE, function (_ref7) {
    var palette = _ref7.theme.palette;
    return transparentize(0.9, palette.black);
  });
}, function (_ref8) {
  var placement = _ref8.placement;
  return placement.startsWith('right') && css(["left:", "rem;top:calc(50% - ", "px);margin-left:0;margin-right:0;text-shadow:1px -5px 5px ", ";transform:rotate(-90deg);"], -CONTENT_PADDING + 0.8, ARROW_SIZE, function (_ref9) {
    var palette = _ref9.theme.palette;
    return transparentize(0.9, palette.black);
  });
});
export var PopoverContentWrapper = styled(motion.div).withConfig({
  displayName: "elements__PopoverContentWrapper",
  componentId: "sc-12ljg9s-1"
})(["background:", ";border-radius:", ";box-shadow:0 0.2rem 0.6rem 0 ", ",0 0.2rem 0.6rem 0 ", ",0 0 0 0.05rem ", ";position:relative;width:", ";", " ", " ", " ", " ", ""], function (_ref10) {
  var palette = _ref10.theme.palette;
  return palette.white;
}, function (_ref11) {
  var dimensions = _ref11.theme.dimensions;
  return dimensions.radius;
}, function (_ref12) {
  var palette = _ref12.theme.palette;
  return transparentize(0.9, palette.black);
}, function (_ref13) {
  var palette = _ref13.theme.palette;
  return transparentize(0.9, palette.mediumGrey);
}, function (_ref14) {
  var palette = _ref14.theme.palette;
  return palette.lightGrey;
}, function (_ref15) {
  var width = _ref15.width;
  return width;
}, function (props) {
  return props['data-placement'] === 'top' && css(["margin-bottom:", "px;"], MARGIN);
}, function (props) {
  return props['data-placement'] === 'bottom' && css(["margin-top:", "px;"], MARGIN);
}, function (props) {
  return props['data-placement'] === 'left' && css(["margin-right:", "px;"], MARGIN);
}, function (props) {
  return props['data-placement'] === 'right' && css(["margin-left:", "px;"], MARGIN);
}, function (props) {
  return props['data-out-of-boundaries'] && css(["visibility:hidden;"]);
});
export var PopoverTriggerWrapper = styled.span.withConfig({
  displayName: "elements__PopoverTriggerWrapper",
  componentId: "sc-12ljg9s-2"
})(["display:inline-block;height:inherit;width:inherit;"]);